import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';

import { getConfig } from 'functions/getConfig';
import { useLoadFreecodeTakeTicket } from 'hooks/useFreecode';
import Path from 'routes/Path';
import { FreecodeLoading } from 'components/FreecodeLoading/FreecodeLoading';
import FreecodePage from 'components/FreecodePage/FreecodePage';
import { useFreecodeContext } from 'hooks/useContext';
import FreecodeEditorComponents from 'components/FreecodePage/FreecodeEditorComponents';
import PageUnderConstruction from 'components/FreecodePage/PageUnderConstruction';

export default function FreecodeTest() {
  const { ticketId } = useParams();

  const [loadingDone, setLoadingDone] = useState(false);
  const [loadingError, setLoadingError] = useState(undefined);
  const [headerLinks, setHeaderLinks] = useState([]);

  const { setTest, setTestImpl, setLanguageData, setLanguage, setSubmit, setCode, setInput, setTicket } =
    useFreecodeContext();
  const ticketRef = useRef(undefined);

  const [freecodeData /** ignore next */, , freecodeDataError] = useLoadFreecodeTakeTicket(ticketId);

  useEffect(() => {
    setSubmit(() => submitCodeTest);
  }, [setSubmit]);

  useEffect(() => {
    if (!ticketId) return;
    setHeaderLinks([
      {
        link: `${getConfig().REDIRECTION_ROOT_URL}/freecode/${ticketId}/ticket`,
        label: 'Old Editor',
      },
    ]);
  }, [ticketId]);

  useEffect(() => {
    if (!freecodeData) return;
    // When loading is done destructure the data
    try {
      const {
        languageVersions,
        freecodeResponse: { test, testImpl, ticket, input },
      } = freecodeData;
      let allowedLanguages = languageVersions[testImpl.executionVersion];
      if (ticket.languagesAllowed?.length) {
        allowedLanguages = {};
        for (const language of ticket.languagesAllowed) {
          allowedLanguages[language] = languageVersions[testImpl.executionVersion][language];
        }
      }
      const foundLanguage =
        input?.language || (allowedLanguages['python'] ? 'python' : Object.keys(allowedLanguages)[0]);
      setInput(input);
      setTest(test);
      setTestImpl(testImpl);
      setLanguageData(allowedLanguages);
      setLanguage(foundLanguage);
      setCode(input?.code || testImpl.generated?.skeletons?.[foundLanguage] || 'Code not found...');
      setTicket(ticket);
      ticketRef.value = ticket;
      setLoadingDone(true);
    } catch (error) {
      setLoadingError('Could not unpack freecode data');
    }
  }, [freecodeData, setLanguageData, setLanguage, setTest, setTestImpl, setCode, setInput, setTicket]);

  const submitCodeTest = () => {
    // TODO implement submit function
    alert('Code test submit not implemented');
  };

  return (
    <FreecodePage headerLinks={headerLinks}>
      <FreecodeLoading
        signInRequired
        loading={!loadingDone}
        errors={[freecodeDataError, loadingError]}
        errorLinkText="All Tests"
        errorLink={Path.candidateTicketsPage}
      />
      <PageUnderConstruction />
      {loadingDone && <FreecodeEditorComponents />}
    </FreecodePage>
  );
}
